// extracted by mini-css-extract-plugin
export default {"category":"advicesywgz5J","category__button":"advicesVABVnd","category--active":"advicesanjEVl"};